module.exports = __webpack_public_path__ + "static/img/lemon.d1da46c9.gif";